import React, { useState } from 'react';
import { SmilePlus } from 'lucide-react';

const REACTION_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🔥', '👏', '💯'];

export const ReactionPicker = ({ onReact, show }) => {
  if (!show) return null;
  return (
    <div className="flex items-center gap-0.5 bg-slate-800 border border-slate-700 rounded-xl px-1.5 py-1 shadow-xl animate-[fadeIn_0.15s_ease-out]" data-testid="reaction-picker">
      {REACTION_EMOJIS.map(emoji => (
        <button key={emoji} onClick={(e) => { e.stopPropagation(); onReact(emoji); }}
          className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-slate-700 hover:scale-110 transition-all text-sm"
          data-testid={`react-${emoji}`}>
          {emoji}
        </button>
      ))}
    </div>
  );
};

export const ReactionDisplay = ({ reactions, currentUser, onReact }) => {
  if (!reactions || Object.keys(reactions).length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1.5" data-testid="reaction-display">
      {Object.entries(reactions).map(([emoji, users]) => {
        const hasReacted = users.includes(currentUser);
        return (
          <button key={emoji} onClick={(e) => { e.stopPropagation(); onReact(emoji); }}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs transition-all ${
              hasReacted
                ? 'bg-indigo-500/25 border border-indigo-500/40 text-indigo-300'
                : 'bg-slate-800/60 border border-slate-700/50 text-slate-400 hover:border-slate-600'
            }`} data-testid={`reaction-badge-${emoji}`}>
            <span className="text-sm">{emoji}</span>
            <span className="font-medium">{users.length}</span>
          </button>
        );
      })}
    </div>
  );
};
